<svelte:options
  customElement={{
    tag: 'teo-login',
    extend: extendWithStyles,
  }}
/>

<script lang="ts">
  import type { TeoCore } from '@/teoCore/TeoCore';
  import LoginElement from '@/ui/components/auth/LoginElement.svelte';
  import { TeoProvider } from '@/utils/teo-context';

  import { extendWithStyles } from './web-component-utils';

  let { teoCore }: { teoCore?: TeoCore } = $props();
</script>

<TeoProvider {teoCore}>
  <LoginElement />
</TeoProvider>
